import React from 'react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  return <section className="py-20 px-4" data-id="element-242">
      <div className="max-w-5xl mx-auto text-center" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-244">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 text-accent mb-6" data-id="element-245">
            <span className="text-3xl" data-id="element-246">🏆</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4" data-id="element-247">
            SABER-DIGITAL™ MEGAPACK SCOOTER ELÉCTRICO
          </h2>
          <p className="text-xl md:text-2xl text-brand font-semibold mb-2" data-id="element-248">
            3 eBooks + 3 Bonos — Mecánica + Desarme + Fallas + Mantenimiento
          </p>
          <p className="text-lg text-muted mb-12" data-id="element-249">
            420+ páginas — Todo resuelto.
          </p>

          {/* Sequence visualizer */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-250">
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-251">
              <div className="text-2xl mb-2" data-id="element-252">📘</div>
              <div className="font-bold text-white mb-1" data-id="element-253">eBook 1</div>
              <div className="text-sm text-muted" data-id="element-254">Mecánica General</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-255">
              <div className="text-2xl mb-2" data-id="element-256">📗</div>
              <div className="font-bold text-white mb-1" data-id="element-257">eBook 2</div>
              <div className="text-sm text-muted" data-id="element-258">Desarme por Módulos</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-259">
              <div className="text-2xl mb-2" data-id="element-260">📙</div>
              <div className="font-bold text-white mb-1" data-id="element-261">eBook 3</div>
              <div className="text-sm text-muted" data-id="element-262">Fallas + Reparación</div>
            </div>
            <div className="bg-surface border border-accent/30 rounded-xl p-4 text-center relative overflow-hidden" data-id="element-263">
              <div className="absolute top-0 right-0 bg-accent text-black text-[10px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-264">
                PRO
              </div>
              <div className="text-2xl mb-2" data-id="element-265">🎁</div>
              <div className="font-bold text-white mb-1" data-id="element-266">Bonos</div>
              <div className="text-sm text-accent" data-id="element-267">Kit Sistema Pro</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}